/**
 * Ramda barrel — tree-shaken subset of ramda.
 *
 * The webpack ProvidePlugin injects the default export of this file as the
 * global `R`, so every `R.xxx` call across the app resolves here instead of
 * pulling the entire `ramda` package. Only the functions actually used in
 * the codebase are imported, so the bundle ships ~70 functions (plus their
 * internal deps) rather than all 250+.
 *
 * If you need a ramda function that isn't listed here, add it to both the
 * import and the default export below.
 */
import {
  F,
  T,
  __,
  all,
  always,
  any,
  append,
  ascend,
  assoc,
  assocPath,
  clone,
  complement,
  concat,
  descend,
  difference,
  dissoc,
  equals,
  evolve,
  filter,
  find,
  findIndex,
  groupBy,
  gt,
  head,
  identity,
  includes,
  init,
  insert,
  insertAll,
  isEmpty,
  isNil,
  last,
  lt,
  map,
  mapObjIndexed,
  max,
  mergeLeft,
  mergeRight,
  min,
  not,
  omit,
  path,
  pathOr,
  pick,
  pickBy,
  pipe,
  pluck,
  prepend,
  prop,
  propEq,
  propOr,
  props,
  reject,
  remove,
  reverse,
  sort,
  sortBy,
  sortWith,
  sum,
  take,
  takeLast,
  toLower,
  toUpper,
  uniq,
  uniqBy,
  update,
  values,
  whereEq,
  without,
} from 'ramda';
// `R.contains` and `R.merge` are legacy aliases that ramda REMOVED at runtime
// in v0.27 (contains -> includes, merge -> mergeRight). Rather than import the
// deprecated names - which would silently become `undefined` the day ramda is
// bumped past 0.26, breaking ~40 call sites - they are aliased here to their
// exact, still-supported replacements. Verified equivalent:
//   R.contains(x, xs) === R.includes(x, xs)
//   R.merge(a, b)     === R.mergeRight(a, b)   (b's keys win)
const contains = includes;
const merge = mergeRight;

const R = {
  F,
  T,
  __,
  all,
  always,
  any,
  append,
  ascend,
  assoc,
  assocPath,
  clone,
  complement,
  concat,
  contains,
  descend,
  difference,
  dissoc,
  equals,
  evolve,
  filter,
  find,
  findIndex,
  groupBy,
  gt,
  head,
  identity,
  includes,
  init,
  insert,
  insertAll,
  isEmpty,
  isNil,
  last,
  lt,
  map,
  mapObjIndexed,
  max,
  merge,
  mergeLeft,
  mergeRight,
  min,
  not,
  omit,
  path,
  pathOr,
  pick,
  pickBy,
  pipe,
  pluck,
  prepend,
  prop,
  propEq,
  propOr,
  props,
  reject,
  remove,
  reverse,
  sort,
  sortBy,
  sortWith,
  sum,
  take,
  takeLast,
  toLower,
  toUpper,
  uniq,
  uniqBy,
  update,
  values,
  whereEq,
  without,
};

export default R;
